
import React, { useState } from 'react';
import { UserRole, SubscriptionTier } from '../types.ts';

const HelpView = ({ user, onChangeTab, activeTab = 'help' }: any) => {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);

  const faqs = [
    { q: "How do I get more matches?", a: "Matches are refreshed monthly. Higher subscription tiers grant significantly more match requests." },
    { q: "What are points used for?", a: "Professionals earn points per completed call to redeem for rewards." },
    { q: "How long are coffee chats?", a: "Typically 30 minutes." }
  ];

  return (
    <div className="p-12 lg:p-20 bg-slate-50/30 dark:bg-slate-950/30 min-h-screen transition-colors duration-500 overflow-y-auto font-sans">
        <header className="mb-16">
          <span className="text-[10px] font-black uppercase tracking-[0.4em] text-indigo-600 dark:text-indigo-400 mb-3 block">Knowledge Base</span>
          <h1 className="text-6xl font-black text-blue-950 dark:text-white tracking-tighter">Help Hub.</h1>
        </header>

        <div className="max-w-4xl space-y-12">
           <section className="bg-white dark:bg-slate-900 p-12 rounded-[4rem] border border-slate-100 dark:border-slate-800 shadow-4xl group">
              <div className="flex items-center gap-4 mb-8">
                 <div className="w-10 h-10 bg-indigo-600 text-white rounded-xl flex items-center justify-center text-lg"><i className="fas fa-quote-left"></i></div>
                 <h2 className="text-2xl font-black text-blue-950 dark:text-white tracking-tight">Platform Manifesto</h2>
              </div>
              <p className="text-xl text-slate-600 dark:text-slate-300 font-bold leading-relaxed italic pr-12">
                CoffeeConnex replaces random networking with an automated, high-fidelity mentorship lifecycle. We prioritize relational depth over transactional connections.
              </p>
           </section>

           <section className="space-y-8">
              <h2 className="text-3xl font-black text-blue-950 dark:text-white tracking-tighter flex items-center gap-4">
                 <div className="w-2 h-10 bg-indigo-600 rounded-full"></div> Frequently Asked
              </h2>
              <div className="space-y-4">
                {faqs.map((faq, i) => (
                  <div key={i} className="bg-white dark:bg-slate-900 rounded-[2.5rem] border border-slate-100 dark:border-slate-800 overflow-hidden shadow-2xl transition-all">
                    <button onClick={() => setActiveFaq(activeFaq === i ? null : i)} className="w-full p-8 text-left flex justify-between items-center group">
                      <span className="font-black text-lg text-blue-950 dark:text-white group-hover:text-indigo-600 dark:group-hover:text-indigo-400 transition-colors">{faq.q}</span>
                      <i className={`fas fa-chevron-down transition-transform text-slate-300 dark:text-slate-600 ${activeFaq === i ? 'rotate-180 text-indigo-600' : ''}`}></i>
                    </button>
                    {activeFaq === i && (
                      <div className="p-8 bg-slate-50 dark:bg-slate-800/50 text-slate-600 dark:text-slate-400 font-bold text-base leading-relaxed border-t border-slate-100 dark:border-slate-800 animate-in slide-in-from-top-2">
                        {faq.a}
                      </div>
                    )}
                  </div>
                ))}
              </div>
           </section>
        </div>
    </div>
  );
};

export default HelpView;
